export default {
  computed: {
    translations() {
      return this.$dashboardStore.getters.getTranslations;
    },

    languageId() {
      return this.$dashboardStore.getters.getLanguage;
    }
  },

  methods: {
    getTranslation(key) {
      let translationValue = this.translations.find((translation) => {
        return translation.languageId === this.languageId && translation.key === key;
      });

      if (translationValue) {
        return translationValue.value
      }

      return `${key} (MT)`;
    }
  }
}
